// extracted by mini-css-extract-plugin
export default {"Mackerel":"#D2D6D9","White":"#FFFFFF","alertTitle":"G7fb176 G519ebe","ineligibleIngredientsWrapper":"G56f938","ineligibleIngredientsInfoTip":"G61221d"};